import { track_ga } from '@/pages/firebase'

// 特权按钮点击 上传英文
export function privilegeClick(params = {}) {
  track_ga('privilege_click', {
    page: 'membersPrivilege',
    ...params,
  })
}

// 优惠券特权弹窗-查看优惠券
export function privilegeCouponCheck(params = {}) {
  track_ga('privilege_coupon_check', {
    page: 'membersPrivilege',
    ...params,
  })
}

// k币特权弹窗-查看k币
export function privilegeKgoldCheck(params = {}) {
  track_ga('privilege_kgold_check', {
    page: 'membersPrivilege',
    ...params,
  })
}

// 生日特权弹窗-提交/更新生日信息
export function privilegeBirthdaySubmit(params = {}) {
  track_ga('privilege_birthday_submit', {
    page: 'membersPrivilege',
    ...params,
  })
}

// 会员账号信息
export async function memberGrade(page, params = {}) {
  track_ga('member_grade', {
    page,
    ...params,
  })
}
